(function() {
    'use strict';
    
a3_cabin_reports.filter('fltSplit',fltSplit) 

    /**
    * @memberof CabinReports
    * @ngdoc filter
    * @name messageFilter
    * @description 
    *   Filters messages in order to show only the unread.
    * @ngInject
    */
function fltSplit() {
		return function(fltSplit) {
            var formattedFltNo = fltSplit;
            if(typeof fltSplit === 'string' || fltSplit instanceof String){
                formattedFltNo = fltSplit.replace(/(\w{2})/, '$1 ');
            }
			return formattedFltNo;
		};
	}
    })();